export const defaultTitle = 'Car sharing';
export const defaultSiteName = 'Car sharing';
export const defaultDesc = 'Our service offers accessible car rental available at any time for private and business trips';
